export const CursorValues = {
	Crosshair: "crosshair",
	Pointer: "pointer",
	Grab: "grab",
	Grabbing: "grabbing",
	Move: "move",
	Unset: "unset",
} as const;
